/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Standings_Help_Top10Inputs */



/**
* | output |
* | --- |
* | "During preliminaries, players only see the top 10. Full standings show once the finals start." |
*
* @param {Tfield_Standings_Help_Top10Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_standings_help_top10 = /** @type {((inputs?: Tfield_Standings_Help_Top10Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Standings_Help_Top10Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pendant les rondes qualificatives, les joueurs ne voient que le top 10. Le classement complet s'affiche au début de la finale.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Durante las rondas clasificatorias, los jugadores solo ven el top 10. La clasificación completa aparece al empezar la final.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Durante as rodadas classificatórias, os jogadores só veem o top 10. A classificação completa aparece quando a final começa.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durante i round preliminari, i giocatori vedono solo la top 10. La classifica completa appare all'inizio della finale.")
	return /** @type {LocalizedString} */ ("During preliminaries, players only see the top 10. Full standings show once the finals start.")
});